var _style, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2049 1152",
    width: 2049,
    height: 1152,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#f7961c}.b{fill:#fbd50a}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1338.9 497.5c-134.1 25-139.1 48.8-24.8 122.7-132.7-30.5-145.9-11-67.6 100.2-111.1-78.4-130.6-65.1-100.1 67.5-73.9-114.3-97.7-109.2-122.7 24.8-25-134-48.9-139.1-122.7-24.8 30.5-132.6 11-145.9-100.2-67.5 78.4-111.2 65.1-130.7-67.5-100.2 114.3-73.9 109.2-97.7-24.8-122.7 134-25 139.1-48.8 24.8-122.7 132.6 30.5 145.9 11 67.5-100.2 111.2 78.4 130.7 65.1 100.2-67.5 73.8 114.3 97.7 109.2 122.7-24.8 25 134 48.8 139.1 122.7 24.8-30.5 132.6-11 145.9 100.1 67.5-78.3 111.2-65.1 130.7 67.6 100.2-114.3 73.9-109.3 97.7 24.8 122.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m1023.7 684.4c-103.4 0-186.9-83.5-186.9-186.9 0-103.4 83.5-186.9 186.9-186.9 103.3 0 186.9 83.5 186.9 186.9 0 103.4-83.6 186.9-186.9 186.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.9f4ab150ff2dd4b1854cf5d7739042b2.svg";
export { ForwardRef as ReactComponent };